import { useEffect, useState } from "react";
import { remainingMs } from "../utils/groupBasketView";

/*
 * Milliseconds left until a server deadline, redrawn every second. Runs on
 * the server's clock (`serverNow` as it arrived at `receivedAt`), so a phone
 * with the wrong time still shows the right countdown. Displays the deadline;
 * never decides anything with it.
 */
export default function useServerCountdown({ at, serverNow, receivedAt }) {
  const read = () => (at ? remainingMs({ at, serverNow, receivedAt }) : null);
  const [ms, setMs] = useState(read);
  useEffect(() => {
    if (!at) {
      setMs(null);
      return undefined;
    }
    const tick = () => setMs(remainingMs({ at, serverNow, receivedAt }));
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [at, serverNow, receivedAt]);
  return ms;
}
